/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgShared = (props)=>/*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 15 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11 8a4 4 0 1 0-3.774-2.672l-2.121 1.06a3.5 3.5 0 1 0 1.291 5.077l2.69 1.384A2.503 2.503 0 0 0 11.5 16a2.5 2.5 0 1 0-1.966-4.045l-2.7-1.388C6.942 10.231 7 9.872 7 9.5c0-.95-.38-1.813-.994-2.444l1.668-.834A3.996 3.996 0 0 0 11 8Zm0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm-7.5 5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    }));
export default SvgShared;
